<template>
    <c-inspection-data
        :has-data    = "true"
        status       = "X"
        :show-header = "false"
        :height      = "height"
        :show-border = "true"
        title       = "Kontakte"
    >
        <template v-slot:body>
            <div class="v-flex mt-3 mr-2 pl-5" :key = "refresh">
                <div class="w-50 pr-2">
                    <p-inspection-contact-iterator
                        :contacts = "inspection.unit.contact.onSite"
                        @favorite = "onFavorite"
                    />
                </div>
                <div class="w-50 pl-2">
                    <p-inspection-contact-iterator
                        :contacts = "inspection.unit.contact.customer"
                        @favorite = "onFavorite"
                    />
                </div>
            </div>
        </template>
    </c-inspection-data>
</template>

<script>

import PAreaMixin from "@/modules/dis/components/inspection/common/mixins/PAreaMixin";
import CInspectionData from "@/modules/dis/components/inspection/common/components/CInspectionData.vue";
import PInspectionContactIterator
    from "@/modules/dis/components/inspection/contacts/components/private/PInspectionContactIterator.vue";
import Disposition from "@/modules/dis/service/Disposition";
import Core from "@/modules/core/service/Core";

export default {
    name: "CInspectionContacts",

    components: {
        PInspectionContactIterator,
        CInspectionData
    },

    mixins: [
        PAreaMixin
    ],

    data: () => ({
        refresh: 0,
    }),

    methods: {
        onFavorite (contact) {
            const contacts = [];
            this.inspection.unit.contact.onSite  .forEach(contact => contacts.push(contact));
            this.inspection.unit.contact.customer.forEach(contact => contacts.push(contact));
            contacts.forEach(contact => contact.favorite = false);

            if (contact) {
                const selected = contacts.find(c => c.id === contact.id);
                if (selected) {
                    selected.favorite = true;
                    Disposition.inspection.unit.setFavoriteContact(this.inspection, contact.id).then(() => {
                        Core.message.alert.save(this);
                        this.$emit("favorite", contact)
                    });

                }
            }

            this.refresh ++;
        }
    }
}
</script>

<style scoped>

</style>